import React from 'react';
import styled from 'styled-components';
import {CircularProgress} from '@material-ui/core';
import {useTranslation} from 'react-i18next';

const Root = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
    align-self: stretch;
    box-sizing: border-box;
    min-height: ${(p) => p.$minHeight}px;
    padding: ${(p) => p.$padding};
    border-radius: 14px;
    background: linear-gradient(
        135deg,
        rgba(0, 0, 0, 0.22) 0%,
        rgba(10, 14, 35, 0.5) 100%
    );
    border: 1px solid rgba(242, 146, 5, 0.16);
    box-shadow:
        inset 0 1px 0 rgba(255, 255, 255, 0.05),
        0 6px 24px rgba(0, 0, 0, 0.28);
`;

const Caption = styled.span`
    margin-top: 14px;
    font-size: 0.8rem;
    font-weight: 600;
    color: rgba(200, 210, 235, 0.78);
    letter-spacing: 0.04em;
    text-transform: uppercase;
`;

/**
 * Loading centralizado (horizontal e vertical) com tema escuro + âmbar do app.
 */
export default function PageLoadingSpinner({minHeight = 160, padding = '28px 20px', className}) {
    const {t} = useTranslation();
    return (
        <Root
            className={className}
            $minHeight={minHeight}
            $padding={padding}
            aria-busy="true"
            aria-live="polite"
        >
            <CircularProgress
                size={44}
                thickness={3.6}
                style={{
                    color: '#f29205',
                    filter: 'drop-shadow(0 0 14px rgba(242, 146, 5, 0.42))',
                }}
            />
            <Caption>{t('loading')}</Caption>
        </Root>
    );
}
